// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"64671953","404":"d459a446","415":"7b4d1b70"}[chunkId] + ".chunk.js";
};